import { SwitchLocale, ZsuButton } from 'src/modules/header';
import { Messengers } from 'src/modules/messengers';
import StylishLink from 'src/ui-kit/StylishLink';
import { useTheme } from 'src/ui-kit/theme';
import replaceTemplateWithCurrentYear from 'src/utils/replaceTemplateWithCurrentYear';
import { useLocalize } from '../../services/localize/useLocalize';
import { Typography } from '../../ui-kit/Typography';
import CenteringComponent from '../CenteringComponent';
import Logo from '../Logo/Logo';
import Responsive from '../Responsive';
import { FooterStyled } from './Footer.styles';
import FooterMenu from './FooterMenu/FooterMenu';
import FooterSocials from './FooterSocials/FooterSocials';
import FooterUpButton from './FooterUpButton/FooterUpButton';
import useLang from 'src/services/language/useLang';

const Footer = () => {
  const lang = useLang();
  const theme = useTheme();
  const localize = useLocalize();

  return (
    <FooterStyled
      theme={theme}
      className="Footer"
    >
      <CenteringComponent>
        <div className="Footer__topLine">
          <div className="Footer__column">
            <div className="Footer__logo">
              <Logo size='large' language={lang} />
            </div>
            <Responsive displayOn='phoneTablet'>
              <div className='Footer__lang'>
                <SwitchLocale />
              </div>
              <div className='Footer__zsuLink'>
                <ZsuButton />
              </div>
            </Responsive>
            <Typography
              variant='text3'
              sbs={{ mb: '16px' }}
            >
              {localize('contact_us')}
            </Typography>
            <Messengers variant='line' />
            <StylishLink
              href={localize('contact_center.support_form')}
              target="_blank"
              dataMarker='Support button'
              variant='accented'
              sbs={{
                display: 'inline-block',
                mt: '20px',
                fontSize: '14px',
              }}
            >
              {localize('contact_center.support_button')}
            </StylishLink>
          </div>

          <div className="Footer__column Footer__column_wide">
            <div className='Footer__flexWrap'>
              <FooterMenu />
              <FooterSocials />
            </div>
          </div>
        </div>

        <div className="Footer__bottomLine">
          <Typography
            variant={{general: 'text2', phone: 'text6'}}
            color='gray500'
            dataMarker='Copyright'
          >
            {replaceTemplateWithCurrentYear(localize('copyright_text'), '%year%')}
          </Typography>
          <FooterUpButton />
        </div>

      </CenteringComponent>
    </FooterStyled>
  );
};

export default Footer;
